import BaseNode from "./BaseNode"
import ActorNode from "./ActorNode"
import ProcessNode from "./ProcessNode"
import ExternalNode from "./ExternalNode"
import DecisionNode from "./DecisionNode"
import HubNode from "./HubNode"
import GroupNode from "./GroupNode"

// Node type registry - defined outside component for stability
export const nodeTypes = {
  base: BaseNode,
  actor: ActorNode,
  process: ProcessNode,
  external: ExternalNode,
  decision: DecisionNode,
  hub: HubNode,
  group: GroupNode,
}

export { BaseNode, ActorNode, ProcessNode, ExternalNode, DecisionNode, HubNode, GroupNode }
